export const SUBJECT = 'subject';
export const BODY = 'body';
export const EMAIL_ADDRESSES = 'emailAddresses';
export const TEAM_IDS = 'teamIds';
export const USER_IDS = 'userIds';
export const OWNER_PROPERTIES = 'ownerProperties';
// To be supported in future version
// export const OWNER_IDS = 'ownerIds';
export const ACTION_TYPE = 'actionType';